

function countGlobalChildren (scenes) {
  let childrenCount = 0;
  for (let s of scenes) {
    childrenCount += s.children.length;
  }
  return childrenCount;
}

function numberMap (n, aStart, aStop, bStart, bStop) {
  return bStart + (bStop - bStart) * ((n - aStart) / (aStop - aStart));
}

function rotatePointAround (point, x, y, angle, distance) {
  point.x = x + (distance * Math.cos(angle));
  point.y = y + (distance * Math.sin(angle));

  return point;
}

function SpriteToRect (sprite) {
  let x = sprite.x;
  let y = sprite.y;
  let scaleX = sprite.scaleX === undefined ? 1 : sprite.scaleX;
  let scaleY = sprite.scaleY === undefined ? 1 : sprite.scaleY;
  let width = sprite.width * scaleX;
  let height = sprite.height * scaleY;
  if (x === undefined) { x = 0; }
  if (y === undefined) { y = 0; }
  if (width === undefined) { width = 0; }
  if (height === undefined) { height = 0; }
  x = x - width / 2;
  y = y - height / 2;
  return new Phaser.Geom.Rectangle(x, y, width, height);
}

function isPointInRect (point, rect) {
  return rect.x <= point.x && point.x <= rect.x + rect.width &&
          rect.y <= point.y && point.y <= rect.y + rect.height;
}

function debounce (func, wait, immediate) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export {
  countGlobalChildren,
  numberMap,
  rotatePointAround,
  SpriteToRect,
  isPointInRect,
  debounce
};
